var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({
      color: ("var(--" + _vm.color + "-600)"),
      textShadow: ("-4px 2px var(--" + _vm.shadowColor + "-600)")
    }),attrs:{"id":"bg-pattern"}},[_vm._v("\n    "+_vm._s(_vm.pattern)+"\n  ")]),_c('h1',{attrs:{"id":"logo"}},[_vm._v("Tech:Ethics")])])}
var staticRenderFns = []

export { render, staticRenderFns }